import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';

export interface Filter {
  _id: string;
  name: string;
  rule: string;
  owner: boolean;
  isPublic?: boolean;
  createdBy?: string;
  enabled?: boolean;
  selected?: boolean;
}

export interface FilterState {
  data: Filter[];
  error?: ErrorObject;
}

const initialState = {
  data: [] as Filter[]
} as FilterState;

export default initialState;
